import {AiResponsePartComponent} from './AiResponsePartComponent';
import {ChannelMenuPartComponent} from './ChannelMenuPartComponent';
import {CheckoutStudioBuilderFormStatePartComponent} from './CheckoutStudioBuilderFormStatePartComponent';
import {FollowUpCaseOptionsPartComponent} from './FollowUpCaseOptionsPartComponent';
import {ProgressPartComponent} from './ProgressPartComponent';
import {SourcesPartComponent} from './SourcesPartComponent';
import {
  AnyMessagePartModule,
  defineMessagePartModule,
} from '../MessagePartModule';

export const aiResponsePart = defineMessagePartModule({
  partType: 'ai_response',
  Component: AiResponsePartComponent,
});

export const channelMenuPart = defineMessagePartModule({
  partType: 'channel_menu',
  Component: ChannelMenuPartComponent,
});

// Registered in the platform defaults for now; moves to a checkout-studio
// owned package in the proof-case phase of the team-owned parts design.
export const checkoutStudioBuilderFormStatePart = defineMessagePartModule({
  partType: 'checkout_studio_builder_form_state',
  Component: CheckoutStudioBuilderFormStatePartComponent,
});

// New type name for the parts-array schema format; same component as above.
export const checkoutStudioBuilderStatePart = defineMessagePartModule({
  partType: 'checkout_studio_builder_state',
  Component: CheckoutStudioBuilderFormStatePartComponent,
});

export const followUpCaseOptionsPart = defineMessagePartModule({
  partType: 'follow_up_case_options',
  Component: FollowUpCaseOptionsPartComponent,
});

export const progressPart = defineMessagePartModule({
  partType: 'progress',
  Component: ProgressPartComponent,
});

export const sourcesPart = defineMessagePartModule({
  partType: 'sources',
  Component: SourcesPartComponent,
});

/**
 * The platform-owned part modules every surface gets by default via
 * `MessagePartComponentProvider`.
 */
export const platformDefaultParts: readonly AnyMessagePartModule[] = [
  aiResponsePart,
  checkoutStudioBuilderFormStatePart,
  checkoutStudioBuilderStatePart,
  channelMenuPart,
  followUpCaseOptionsPart,
  progressPart,
  sourcesPart,
];
